import React, { useEffect } from 'react';
import { Map } from 'immutable';
import { useSelector, useDispatch } from 'react-redux';
import {
  Node,
  Taxonomy as TaxonomyTerm,
  entityGetByPath,
  ContextualActionsWrapper,
  Profile,
} from '@uncinc/react-drupal-core';

import { usePrevious } from '@uncinc/uncinc-react-kitchen-sink';

import Page from '../Page';
import Forbidden from '../Forbidden';
import NotFound from '../NotFound';
import ServerError from '../ServerError';

import ErrorBoundary from '../../components/ErrorBoundary';

const Entity = () => {
  const dispatch = useDispatch();

  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const childEntity = useSelector((state) => state.getIn([entityType, entityId], Map()));
  const path = useSelector((state) => state.getIn(['router', 'location', 'pathname']));
  const entityStatus = useSelector((state) => state.getIn(['entity', 'status']));
  const entityExists = useSelector((state) => state.getIn(['entity', 'exists']));

  const prevPath = usePrevious(path);
  const entityNotLoaded = !entityType || !entityId;
  const pathIsDifferentAndHasEntity =
    (path !== prevPath && typeof prevPath !== 'undefined') &&
    (typeof entityStatus !== 'undefined' && entityStatus !== null);

  useEffect(() => {
    if (entityNotLoaded || (!entityNotLoaded && pathIsDifferentAndHasEntity)) {
      dispatch(entityGetByPath(path));
    }
  }, [dispatch, entityNotLoaded, pathIsDifferentAndHasEntity, path]);

  if ((!entityType || !entityId) && entityExists) {
    return null;
  }

  if (entityStatus === 403) {
    return (
      <Forbidden />
    );
  } else if (entityStatus === 404) {
    return (
      <NotFound />
    );
  } else if (entityStatus === 500) {
    return (
      <ServerError />
    );
  }

  return (
    <ContextualActionsWrapper>
      <Page title={childEntity.getIn(['title', 0, 'value'], '')} path={path} prevPath={prevPath}>
        <ErrorBoundary>
          {entityType === 'node' && (
            <Node root id={entityId} />
          )}
          {entityType === 'taxonomy_term' && (
            <TaxonomyTerm root id={entityId} />
          )}
          {entityType === 'profile' && (
            <Profile root id={entityId} />
          )}
        </ErrorBoundary>
      </Page>
    </ContextualActionsWrapper>
  );
};

export default Entity;
